import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials, contactInfo } from '../data/mock';

const TestimonialsSection = () => {
  const whatsappUrl = `https://wa.me/${contactInfo.whatsapp.replace(/\D/g, '')}?text=${encodeURIComponent(contactInfo.whatsappMessage)}`;

  return (
    <section className="py-24 bg-section">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-4">Historias de Éxito de Nuestros Pacientes</h2>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            Lee lo que dicen nuestros pacientes sobre sus experiencias transformadoras 
            con nuestros tratamientos dermatológicos.
          </p>
        </div>

        {/* Testimonials Grid - Show featured testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16">
          {testimonials.slice(0, 9).map((testimonial, index) => {
            const accentClasses = ['accent-purple', 'accent-blue', 'accent-orange', 'accent-pink', 'accent-green', 'accent-grey-200'];
            const accentClass = accentClasses[index % accentClasses.length];
            
            return (
              <div key={testimonial.id} className={`voice-card ${accentClass} hover-lift`}>
                {/* Quote Icon and Rating */}
                <div className="flex items-center justify-between mb-4">
                  <Quote size={24} className="text-primary/60" />
                  <div className="flex">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} size={14} className="text-accent-orange-400 fill-current" />
                    ))}
                  </div>
                </div>

                {/* Testimonial Text */}
                <p className="voice-card-description mb-4 text-primary italic">
                  "{testimonial.text}"
                </p>

                {/* Patient Info */}
                <div className="flex items-center justify-between mt-auto">
                  <div>
                    <div className="voice-card-title text-sm">{testimonial.name}</div>
                    <div className="caption">{testimonial.treatment}</div>
                  </div>
                  {testimonial.date && (
                    <div className="caption text-xs bg-white/30 px-2 py-1 rounded">
                      {testimonial.date}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {/* More Testimonials Button */}
        <div className="text-center mb-16">
          <div className="voice-card accent-grey-200 inline-block p-6 max-w-md">
            <h3 className="heading-3 mb-3">Ver Más Testimonios</h3>
            <p className="body-small text-secondary mb-4">
              Tenemos {testimonials.length} testimonios reales de pacientes satisfechos.
            </p>
            <a href="/testimonios" className="btn-secondary inline-block">
              Ver Todos los Testimonios
            </a>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="voice-card accent-grey-200 inline-block p-8 max-w-lg">
            <h3 className="heading-3 mb-3">¿Listo para Transformar tu Piel?</h3>
            <p className="body-small text-secondary mb-4">
              Únete a cientos de pacientes satisfechos que han logrado sus objetivos de salud cutánea con nuestra atención especializada.
            </p>
            <a href={whatsappUrl} className="btn-primary inline-block">
              Comienza tu Transformación
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;